export const getMqStoreIds = () => {
  const mqStores = process._repository?._mq?.stores
  return Object.keys(mqStores?.stores ?? {})
}

export const getMqPpageIds = () => {
  const mqPpages = process._repository?._mq?.ppages
  return Object.keys(mqPpages?.ppages ?? {})
}
